import AnimatedCharacter from "../../AnimatedCharacter";

export default class Pet extends AnimatedCharacter {
    constructor(name, type) {
        super(name);

        this._type = type;

        this.setIdleAnims(["idle1"]);
        this.setAttackAnims(["attack"]);
        this.setDamageAnims(["damage"]);
        this.setDefeatAnims(["defeat"]);
        this.setVictoryAnims(["victory"]);
    }

    get type() {
        return this._type;
    }
}

Pet.TYPE_OWL = 1;
Pet.TYPE_BAT = 2;
Pet.TYPE_DRAGON = 3;
Pet.TYPE_RAVEN = 4;